export const AFYA_IMARA_MEDICAL_HISTORY = 'afyaImara/medicalHistory/';

export const AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY + 'setValue/';
export const AFYA_IMARA_MEDICAL_HISTORY_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY + 'setValid/';

export const FORM_VALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM = 'afyaImara/medicalHistoryForm/transition/formValid';
export const FORM_INVALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM = 'afyaImara/medicalHistoryForm/transition/formInValid';

export const REINITIALIZE = 'afyaImara/medicalHistoryForm/state/reinitialize';
export const RESET_FORM = 'afyaImara/medicalHistoryForm/state/resetForm';

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_NEXT_OF_KIN_FORM = 'afyaImara/medicalHistoryForm/transition/dropOffLead';
export const dropOffLeadNextOfKin = (value) => ({
    type: DROP_OFF_LEAD_TRANSITION_NEXT_OF_KIN_FORM,
    value,
});

export const transitionAfyaImaraMedicalHistoryForm = {
    formValid: () => ({
        type: FORM_VALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_AFYA_IMARA_MEDICAL_HISTORY_NEXT_OF_KIN_FORM,
    }),
};

// API Calls actions
export const API_PENDING_TRANSITION_MEDICAL_HISTORY_FORM = `${AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_MEDICAL_HISTORY_FORM = `${AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_MEDICAL_HISTORY_FORM = `${AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE}/apiTransition/failure`;
export const API_INITIAL_TRANSITION_MEDICAL_HISTORY_FORM = `${AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE}/apiTransition/initial`;

export const apiTransitionMedicalHistoryForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_MEDICAL_HISTORY_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_MEDICAL_HISTORY_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_MEDICAL_HISTORY_FORM,
    }),
    inital: () => ({
        type: API_INITIAL_TRANSITION_MEDICAL_HISTORY_FORM,
    }),
};

//calculated Data
export const COLLECT_NEXT_OF_KIN_FORM_DATA = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'collectNextOfKinData';
export const SUBMIT_NEXT_OF_KIN_SUCCESS = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'success';
export const SUBMIT_NEXT_OF_KIN_FAILURE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'failure';

export const collectNextOfKinData = () => ({
    type: COLLECT_NEXT_OF_KIN_FORM_DATA,
});
export const submitNextOfKinSuccess = (value) => ({
    type: SUBMIT_NEXT_OF_KIN_SUCCESS,
    value,
});
export const submitNextOfKinFailure = (error) => ({
    type: SUBMIT_NEXT_OF_KIN_FAILURE,
    error,
});

// Form Values

export const RELATIONSHIP_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'relationship';
export const RELATIONSHIP_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'relationship';

export const NAME_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'name';
export const NAME_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'name';

export const ID_BIRTH_CERTIFICATE_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'idBirthCertificate';
export const ID_BIRTH_CERTIFICATE_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'idBirthCertificate';

// None of the above
export const NONE_OF_THE_ABOVE_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'noneOfTheAbove';
export const NONE_OF_THE_ABOVE_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'noneOfTheAbove';

// Date of onset
export const DATE_OF_ONSET_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'dateOfOnset';
export const DATE_OF_ONSET_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'dateOfOnset';

//Date of last episode
export const DATE_OF_LAST_EPISODE_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'dateOfLastEpisode';
export const DATE_OF_LAST_EPISODE_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'dateOfLastEpisode';

// Past/current treatment
export const PAST_CURRENT_TREATMENT_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'pastCurrentTreatment';
export const PAST_CURRENT_TREATMENT_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'pastCurrentTreatment';

// additional details 
export const ADDITIONAL_DETAILS_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'additionalDetails';
export const ADDITIONAL_DETAILS_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'additionalDetails';

// diagnosis
export const DIAGNOSIS_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'diagnosis';
export const DIAGNOSIS_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'diagnosis';

// diagnosis
export const HEIGHT_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'height';
export const HEIGHT_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'height';

// diagnosis
export const WEIGHT_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'weight';
export const WEIGHT_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'weight';


// ADD medical history
export const ADD_MEDICAL_HISTORY = AFYA_IMARA_MEDICAL_HISTORY + 'addMedicalHistory';

// Update medical history
export const UPDATE_MEDICAL_HISTORY = AFYA_IMARA_MEDICAL_HISTORY + 'updateMedicalHistory';

// Delete  medical history
export const DELETE_MEDICAL_HISTORY = AFYA_IMARA_MEDICAL_HISTORY + 'deleteMedicalHistory';

// Action creators
export const setRelationshipValue = (value) => ({
    type: RELATIONSHIP_SET_VALUE,
    value,
});

export const setRelationshipValid = (error) => ({
    type: RELATIONSHIP_SET_VALID,
    error,
});

export const setNameValue = (value) => ({
    type: NAME_SET_VALUE,
    value,
});

export const setNameValid = (error) => ({
    type: NAME_SET_VALID,
    error,
});

export const setIdBirthCertificateValue = (value) => ({
    type: ID_BIRTH_CERTIFICATE_SET_VALUE,
    value,
});

export const setIdBirthCertificateValid = (error) => ({
    type: ID_BIRTH_CERTIFICATE_SET_VALID,
    error,
});

export const setDateOfOnsetValue = (value) => ({
    type: DATE_OF_ONSET_SET_VALUE,
    value,
});

export const setDateOfOnsetValid = (error) => ({
    type: DATE_OF_ONSET_SET_VALID,
    error,
});

export const setDateOfLastEpisodeValue = (value) => ({
    type: DATE_OF_LAST_EPISODE_SET_VALUE,
    value,
});

export const setDateOfLastEpisodeValid = (error) => ({
    type: DATE_OF_LAST_EPISODE_SET_VALID,
    error,
});

export const setPastCurrentTreatmentValue = (value) => ({
    type: PAST_CURRENT_TREATMENT_SET_VALUE,
    value,
});

export const setPastCurrentTreatmentValid = (error) => ({
    type: PAST_CURRENT_TREATMENT_SET_VALID,
    error,
});

export const setAdditionalDetailsValue = (value) => ({
    type: ADDITIONAL_DETAILS_SET_VALUE,
    value,
});

export const setAdditionalDetailsValid = (error) => ({
    type: ADDITIONAL_DETAILS_SET_VALID,
    error,
});

export const addMedicalHistory = (value) => ({
    type: ADD_MEDICAL_HISTORY,
    value,
});

export const updateMedicalHistory = (value, index) => ({
    type: UPDATE_MEDICAL_HISTORY,
    value,
    index
});

export const deleteMedicalHistory = (index) => ({
    type: DELETE_MEDICAL_HISTORY,
    index,
});

export const reinitialize = () => ({
    type: REINITIALIZE,
});

export const setDiagnosisValue = (value) => ({
    type: DIAGNOSIS_SET_VALUE,
    value,
});

export const setDiagnosisValid = (error) => ({
    type: DIAGNOSIS_SET_VALID,
    error,
});

export const resetForm = () => ({
    type: RESET_FORM,
});

export const setNoneOfTheAboveValue = (value) => ({
    type: NONE_OF_THE_ABOVE_SET_VALUE,
    value,
});

export const setNoneOfTheAboveValid = (error) => ({
    type: NONE_OF_THE_ABOVE_SET_VALID,
    error,
});

export const ID_NUMBER_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'idNumber';
export const ID_NUMBER_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'idNumber';
export const EMAIL_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'email';
export const EMAIL_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'email';
export const POSTAL_ADDRESS_SET_VALUE = AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE + 'postalAddress';
export const POSTAL_ADDRESS_SET_VALID = AFYA_IMARA_MEDICAL_HISTORY_SET_VALID + 'postalAddress';

// action creators

export const setIdNumberValue = (value) => ({
    type: ID_NUMBER_SET_VALUE,
    value,
});

export const setIdNumberValid = (error) => ({
    type: ID_NUMBER_SET_VALID,
    error,
});

export const setPostalAddressValue = (value) => ({
    type: POSTAL_ADDRESS_SET_VALUE,
    value,
});

export const setPostalAddressValid = (error) => ({
    type: POSTAL_ADDRESS_SET_VALID,
    error,
});

export const setFirstNameValue = (value) => ({
    type: FIRST_NAME_SET_VALUE,
    value,
});
export const setFirstNameValid = (error) => ({
    type: FIRST_NAME_SET_VALID,
    error,
});

export const setLastNameValue = (value) => ({
    type: LAST_NAME_SET_VALUE,
    value,
});
export const setLastNameValid = (error) => ({
    type: LAST_NAME_SET_VALID,
    error,
});


export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});

export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setHeightValue = (value) => ({
    type: HEIGHT_SET_VALUE,
    value,
});

export const setHeightValid = (error) => ({
    type: HEIGHT_SET_VALID,
    error,
});

export const setWeightValue = (value) => ({
    type: WEIGHT_SET_VALUE,
    value,
});

export const setWeightValid = (error) => ({
    type: WEIGHT_SET_VALID,
    error,
});
